import { Import_FileComponent } from 'src/app/Import File/Import_File/Import_File.component';
import { UserTemplatesComponent } from './TemplatesManage/UserTemplates/UserTemplates.component';
import { MigrationComponent } from './Migration/Migration/Migration.component';
import { Routes } from '@angular/router';
import { HomeComponent } from './Home/Home.component';
import { User_ManageComponent } from './User_Manage/User_Manage.component';
import { Log_ManageComponent } from './Log_Manage/Log_Manage.component';
import { Device_ManageComponent } from './Device_Manage/Device_Manage.component';
import { Pass_ManageComponent } from './Pass_Manage/Pass_Manage.component';
import { RealTIme_LogViewComponent } from './RealTIme_LogView/RealTIme_LogView.component';
import { RealTime_Enroll_ViewComponent } from './Real-Time_Enroll_View/Real-Time_Enroll_View.component';

import { ErrorComponent } from './error/error.component';
import { DefaultComponent } from './layouts/default/default.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_guards/auth.guard';
import { GenerateTextFileComponent } from './GenrateTextFile/GenerateTextFile/GenerateTextFile.component';

export const routes: Routes = [
  { path: 'Login', component: LoginComponent },

  {
    path: '',
    canActivate: [AuthGuard],
    component: DefaultComponent,
    children: [
      {
        path: 'Home',
        canActivate: [AuthGuard],
        component: HomeComponent,
      },
      { path: '', canActivate: [AuthGuard], component: HomeComponent },
      {
        path: 'UserManage',
        canActivate: [AuthGuard],
        component: User_ManageComponent,

      },
      {
        path: 'LogManage',
        canActivate: [AuthGuard],
        component: Log_ManageComponent,

      },
      {
        path: 'RealTimeLog',
        canActivate: [AuthGuard],
        component: RealTIme_LogViewComponent,

      },
      {
        path: 'RealTimeEnroll',
        canActivate: [AuthGuard],
        component: RealTime_Enroll_ViewComponent,

      },
      {
        path: 'DeviceManage',
        canActivate: [AuthGuard],
        component: Device_ManageComponent,

      },
      {
        path: 'Migration',
        canActivate: [AuthGuard],
        component: MigrationComponent,

      },
      {
        path: 'Download',
        canActivate: [AuthGuard],
        component: UserTemplatesComponent,

      },
      {
        path: 'Generate',
        canActivate: [AuthGuard],
        component: GenerateTextFileComponent,

      },
      {
        path: 'Import',
        canActivate: [AuthGuard],
        component: Import_FileComponent,

      },
      { path: '**',
       component: ErrorComponent },
    ],
  },
  { path: '**', component: ErrorComponent },

  // { path: '', component: HomeComponent },
  // { path: 'Home', component: HomeComponent },
  // { path: 'UserManage', component: User_ManageComponent },
  // { path: 'error', component: ErrorComponent },
  // { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
